module.exports = __webpack_public_path__ + "img/code.c8cf4d26.png";